import { useEffect, useRef } from "react";

// Função para verificar igualdade de arrays ou objetos simples
function shallowEqual(obj1, obj2) {
  if (obj1 === obj2) return true;
  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    return obj1.length === obj2.length && obj1.every((item, index) => item === obj2[index]);
  }
  if (typeof obj1 === "object" && typeof obj2 === "object") {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    return (
      keys1.length === keys2.length &&
      keys1.every((key) => obj1[key] === obj2[key])
    );
  }
  return false;
}

// Hook personalizado
function useSmartEffect(callback, dependencies) {
  const previousDependencies = useRef([]);

  useEffect(() => {
    const hasChanged = dependencies.some((dep, index) => !shallowEqual(dep, previousDependencies.current[index]));

    if (hasChanged) {
      callback();
    }

    // Atualiza as dependências anteriores
    previousDependencies.current = dependencies;
  }, dependencies); // Depende das dependências fornecidas
}

function useSmartMemo(factory, dependencies) {
  const previousDependencies = useRef([]);
  const previousValue = useRef();

  const hasChanged = dependencies.some(
    (dep, index) => !shallowEqual(dep, previousDependencies.current[index])
  );

  // Somente recalcula o valor se algo mudou
  if (hasChanged) {
    previousValue.current = factory();
    previousDependencies.current = [...dependencies]; // Atualiza dependências
  }

  return previousValue.current;
}

export { useSmartEffect, useSmartMemo };